var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.academyData.ruta_logo)?_c('img',{attrs:{"alt":_vm.academyData.nombre,"src":_vm.academyData.ruta_logo}}):_c('span',[_vm._v("\n    "+_vm._s(_vm.academyData.nombre)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }